var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var upperFirst = function upperFirst(str) {
  return str.charAt(0).toUpperCase() + str.substr(1);
};

var longhand = function longhand(coreProp, prop) {
  return Object.keys(prop).reduce(function (result, key) {
    var k = "" + coreProp + upperFirst(key);
    var v = prop[key];

    return Object.assign({}, result, defineProperty({}, k, v));
  }, {});
};

export default longhand;
